import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const PromotionsDefaultProps = {
  ...ClassNameDefaultProps,
  discountClasses: null,
  isUpdated: false,
};

export const PromotionsPropTypes = {
  ...ClassNamePropTypes,
  discountClasses: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      current_step: PropTypes.shape({
        level: PropTypes.number,
        percentage: PropTypes.number,
      }),
      label: PropTypes.string,
      missing_amount: PropTypes.number,
      next_step: PropTypes.oneOfType([
        PropTypes.shape({
          level: PropTypes.number,
          percentage: PropTypes.number,
        }),
        PropTypes.arrayOf(PropTypes.shape({})),
      ]),
      steps: PropTypes.arrayOf(
        PropTypes.shape({
          discount_amount: PropTypes.number,
          discount_percentage: PropTypes.number,
          level: PropTypes.number,
        }),
      ),
    }),
  ),
  isUpdated: PropTypes.bool,
};
